import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDataLayer } from 'hooks/useDataLayer';
import AppLink from 'components/AppLink';

const Crumb = ({ context, title, url, ...rest }) => {
  const { emitInteractionEvent } = useDataLayer();

  const handleClick = useCallback(() => {
    emitInteractionEvent({ type: 'Navigation Breadcrumb', value: `${context} Selected` });
  }, [context, emitInteractionEvent]);

  return (
    <AppLink to={url} color="greys.steel" py={4} onClick={handleClick} {...rest} data-testid="crumb-link">
      {title}
    </AppLink>
  );
};

Crumb.propTypes = {
  context: PropTypes.string.isRequired,
  title: PropTypes.string,
  url: PropTypes.string,
};

Crumb.defaultProps = {
  title: '',
  url: '',
};

export default Crumb;
